import axiosRequest from '@/utils/request'
import axios from 'axios'
// 单笔限额
export const limitAmount = (params) => {
  return axiosRequest({
    url: '/trade/limit-amount',
    params,
    method: 'get'
  })
}
// 提现
export const withdraw = (data) => {
  return axiosRequest({
    url: '/trade/withdraw',
    data,
    method: 'post',
    showMessage: false
  })
}

// 单笔限额
export const singList = (params) => {
  return axiosRequest({
    url: '/sign/list',
    params,
    method: 'get'
  })
}

// 银行列表
export const bankList = (params) => {
  return axiosRequest({
    url: '/basic-data/get-bank-list',
    params,
    method: 'get'
  })
}

// 全部
export const walletAll = (params) => {
  return axiosRequest({
    url: '/wallet/home-page',
    params,
    method: 'get'
  })
}

// 结果页面
export const tradeDetail = (data, cancelToken) => {
  return axiosRequest({
    url: '/trade/trade-detail',
    data,
    method: 'post'
  }, {
    cancelToken: new axios.CancelToken((cancel) => {
      cancelToken && cancelToken(cancel)
    })
  })
}
